<div style="display: inline-block; margin-top: 1px">
    <span style="margin-right: 15px">
        <div class="legend-1"></div>
        &lt; -5% Impact
    </span>
    <span style="margin-right: 15px">
        <div class="legend-2"></div>
        -5% - 0% Impact
    </span>
    <span style="margin-right: 15px">
        <div class="legend-3"></div>
        0% - 5% Impact
    </span>
    <span>
        <div class="legend-4"></div>
        &gt; 5% Impact
    </span>
</div>
<plotly-plot [data]="graph.data" [config]="graph.config" (plotlyClick)="handleTreemapClick($event)" [layout]="graph.layout"></plotly-plot>
